import { render, staticRenderFns } from "./GiveupDialog.vue?vue&type=template&id=291cc91c&scoped=true&"
import script from "./GiveupDialog.vue?vue&type=script&lang=js&"
export * from "./GiveupDialog.vue?vue&type=script&lang=js&"
import style0 from "./GiveupDialog.vue?vue&type=style&index=0&id=291cc91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291cc91c",
  null
  
)

component.options.__file = "GiveupDialog.vue"
export default component.exports